import { log } from "@/core/logger";
import { fetchWithAuth } from "@/utils/fetchWithAuth";
import { API_BASE_URL } from "./helpers";
import type { IAnalyticsAPI } from "./analyticsApi";
import type { AnalyticsDashboard } from "@/types/Analytics";

class RemoteAnalyticsAPI implements IAnalyticsAPI {
  async fetchDashboard(): Promise<AnalyticsDashboard> {
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/api/analytics/dashboard`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
      const result = await response.json();

      if (result.data) {
        return result.data as AnalyticsDashboard;
      }

      return result as AnalyticsDashboard;
    } catch (error) {
      log("remoteAnalyticsApi", "Failed to fetch analytics dashboard", error);
      throw error;
    }
  }
}

export default RemoteAnalyticsAPI;
